var _style, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_00000170985551442005239940000008275817767919631271_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -667.7577,
    y1: -75.6319,
    x2: -668.6026,
    y2: -74.921,
    gradientTransform: "matrix(776 0 0 776 518949.125 58854.5469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6509E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2EBAC6"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M633.4,616.2L484.4,256c-8.4-18.6-20.9-27.7-37.4-27.7h-13.2c-16.5,0-29,9.1-37.4,27.7l-64.8,156.9h-49.1 c-14.6,0.1-26.6,11.9-26.7,26.7v0.3c0.1,14.6,12,26.6,26.7,26.7H309l-61.9,149.6c-1.1,3.3-1.8,6.7-1.8,10.2 c0,8.4,2.6,15,7.3,20.1c4.7,5.1,11.4,7.6,19.8,7.6c5.6-0.1,10.9-1.8,15.3-5.1c4.8-3.3,8.1-8.1,10.7-13.5l68.1-169h47.2 c14.6-0.1,26.6-11.9,26.7-26.7v-0.7c-0.1-14.6-12-26.6-26.7-26.7h-25.2l52-129.6l141.7,352.5c2.6,5.5,5.9,10.2,10.7,13.5 c4.4,3.3,9.9,5,15.3,5.1c8.4,0,15-2.5,19.8-7.6c4.8-5.1,7.3-11.7,7.3-20.1C635.4,622.9,634.8,619.3,633.4,616.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "b_00000047047048732633146320000014976048055228059788_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116929381640356486990000007368935050888691636_",
    gradientUnits: "userSpaceOnUse",
    x1: -667.7577,
    y1: -75.6319,
    x2: -668.6026,
    y2: -74.921,
    gradientTransform: "matrix(776 0 0 776 518949.125 58854.5469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6509E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2EBAC6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000116929381640356486990000007368935050888691636_)"
    },
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M633.4,616.2L484.4,256c-8.4-18.6-20.9-27.7-37.4-27.7h-13.2c-16.5,0-29,9.1-37.4,27.7l-64.8,156.9h-49.1 c-14.6,0.1-26.6,11.9-26.7,26.7v0.3c0.1,14.6,12,26.6,26.7,26.7H309l-61.9,149.6c-1.1,3.3-1.8,6.7-1.8,10.2 c0,8.4,2.6,15,7.3,20.1c4.7,5.1,11.4,7.6,19.8,7.6c5.6-0.1,10.9-1.8,15.3-5.1c4.8-3.3,8.1-8.1,10.7-13.5l68.1-169h47.2 c14.6-0.1,26.6-11.9,26.7-26.7v-0.7c-0.1-14.6-12-26.6-26.7-26.7h-25.2l52-129.6l141.7,352.5c2.6,5.5,5.9,10.2,10.7,13.5 c4.4,3.3,9.9,5,15.3,5.1c8.4,0,15-2.5,19.8-7.6c4.8-5.1,7.3-11.7,7.3-20.1C635.4,622.9,634.8,619.3,633.4,616.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaveIcon);
export default __webpack_public_path__ + "static/media/aave_icon.d18a438a880a31ed04c0fc872f5a2fb7.svg";
export { ForwardRef as ReactComponent };